const pathnamePrefixes = ['/jira/', '/wiki/', '/browse/'];
const ATLAS_HOST = 'home.atlassian.com';
const ATLAS_TEAM_HOST = 'team.atlassian.com';
const UUID_REGEX = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;

export const normaliseUrl = (url: string): string => {
	try {
		let parsedUrl = new URL(url);

		let normalizedPath = '/any/';
		if (parsedUrl.host === ATLAS_HOST || parsedUrl.host === ATLAS_TEAM_HOST) {
			// Replace org ID with "orgId" in the path
			normalizedPath = parsedUrl.pathname.replace(/\/o\/[^/]+/, '/o/orgId');
		}

		const prefixRegex = new RegExp(`^(${pathnamePrefixes.join('|')})`);
		if (prefixRegex.test(parsedUrl.pathname)) {
			normalizedPath = parsedUrl.pathname.match(prefixRegex)![0];
		}

		const normalizedUrl = `${parsedUrl.protocol}//${parsedUrl.host}${normalizedPath}`;
		return normalizedUrl;
	} catch (error) {
		return 'https://could-not-parse.example.com';
	}
};

export const normalizeUUID = (
	str: string | null | undefined,
): { normalized: string; matchedUUIDs: string[] } => {
	if (!str) {
		return { normalized: '', matchedUUIDs: [] };
	}
	const matchedUUIDs = str.match(UUID_REGEX) || [];
	const normalized = str.replace(UUID_REGEX, '{uuid}');

	return { normalized, matchedUUIDs };
};
